'use client'

import React, { createContext, useState, useContext } from 'react'

type CreateRegisterType = {
    openBusiness: boolean
    setOpenBusiness: (openBusiness: boolean) => void
    openContact: boolean
    setOpenContact: (openContact: boolean) => void
    openCompany: boolean
    setOpenCompany: (openCompany: boolean) => void
    openProduct: boolean
    setOpenProduct: (openProduct: boolean) => void
    openTask: boolean
    setOpenTask: (openTask: boolean) => void
    openEvent: boolean
    setOpenEvent: (openEvent: boolean) => void
    openCall: boolean
    setOpenCall: (openCall: boolean) => void
}

const CreateRegister = createContext<CreateRegisterType | undefined>(undefined)

export const CreateRegisterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [openBusiness, setOpenBusiness] = useState(false)
    const [openContact, setOpenContact] = useState(false)
    const [openCompany, setOpenCompany] = useState(false)
    const [openProduct, setOpenProduct] = useState(false)
    const [openTask, setOpenTask] = useState(false)
    const [openEvent, setOpenEvent] = useState(false)
    const [openCall, setOpenCall] = useState(false)

    return (
        <CreateRegister.Provider
            value={{
                openBusiness,
                setOpenBusiness,
                openContact,
                setOpenContact,
                openCompany,
                setOpenCompany,
                openProduct,
                setOpenProduct,
                openTask,
                setOpenTask,
                openEvent,
                setOpenEvent,
                openCall,
                setOpenCall
            }}
        >
            {children}
        </CreateRegister.Provider>
    )
}

export function useCreate() {
    const context = useContext(CreateRegister)
    if (context === undefined) {
        throw new Error('useCreate must be used within a CreateRegisterProvider')
    }
    return context
}
